// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[data-bs-toggle="tooltip"]', (element) => {
  const $element = jQuery(element)

  $element.tooltip()
})

up.compiler('[data-bs-toggle="popover"]', (element) => {
  const $element = jQuery(element)
  $element.popover()

  return () => {
    $element.popover('destroy')
  }
})

up.compiler('.datepicker[up-validate]', (element) => {
  const $element = jQuery(element)
  $element.on('changeDate', () => {
    up.validate($element[0], { target: $element[0].getAttribute('up-validate') })
  })
})
